<template>
  <v-container fluid>
<!--     <v-row>
      <v-col class="text-right">
        <v-menu
          v-model="createMenuToggle"
          dense
        >
          <template v-slot:activator="{ on }">
            <v-btn
              style="margin-top:15px;"
              depressed
              v-on="on"
            >
              <v-icon
                small
                left
              >
                mdi-plus
              </v-icon>
              Create
            </v-btn>
          </template>
          <v-list
            class="pr-5"
            subheader
          >
            <v-subheader>Create New</v-subheader>
            <object-list-create-item
              v-for="a in $appConfig.objects"
              :key="a.type"
              :action="a"
              @create="(e)=>{handleObjectCreated(a,e)}"
              @close="createMenuToggle=false"
            />
          </v-list>
        </v-menu>
      </v-col>
    </v-row> -->
    <v-row>
      <v-col>
        <span class="title">Library</span>
      </v-col>
    </v-row>
    <v-row
      v-for="action in $appConfig.objects"
      :key="action.type"

      class="mb-0 pb-0 pt-0"
    >
      <template v-if="typeof library[action.plural] !== 'undefined' && library[action.plural].length > 0">
        <v-col
          cols="12"
          class="mb-0 pb-0"
        >
          {{ action.label }}
        </v-col>
        <v-col

          cols="12"
        >
          <v-list
            flat
            subheader
          >
            <v-list-item-group>
              <v-divider />
              <object-list-item
                v-for="(d, index) in library[action.plural]"
                :key="index"
                :ref="'object-'+action.type+'-'+d.name"
                :type="action.type"
                :object="d"
                @update="get"
                @delete="get"
              />
              <v-divider />
            </v-list-item-group>
          </v-list>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
  import ObjectListItem from './../../../UIComponents/ObjectListItem'
  import ObjectListCreateItem from './../../../UIComponents/ObjectListCreateItem'
  import LibraryService from './services/LibraryService'

  export default {
    components: {
      ObjectListCreateItem,
      ObjectListItem,
    },
    data () {
      return {
        library: {},
        //
        isInitiated: false,
        isLoading: false,
        createMenuToggle: false,
      }
    },
    mounted () {
      this.get()
    },
    methods: {
      handleObjectCreated (a, e) {},
      get () {
        let self = this
        self.isLoading = true
        LibraryService.get().then(lib => {
          self.library = lib
        }).finally(() => {
          self.isLoading = false
          self.isInitiated = true
        })
      },
    },
  }
</script>
